<template>
  <!-- 外部ユーザー編集 -->
  <div id="ExternalUserEdit" v-if="data">
    <div id="container">
      <template v-if="from !='control'">
        <masterNavi v-bind:pageid='"UserManage"'></masterNavi>
        <div class="labelTitle lable">ユーザー管理</div>
        <userNavi v-bind:pageid='"ExternalUserSearch"'></userNavi>
      </template>
      <div v-if="data.status==extUserStatus.registed" class="labelTitle lable">外部ユーザー編集</div>
      <div v-else class="labelTitle lable">外部ユーザー登録</div>
      <!-- 変更内容 -->
      <div>
        <div id="item-contens">
          <div v-if="from !='control' && data.userInfo.lock" class="card-content margin-top">
            <table>
              <tr>
                <td><span style="color: red">このユーザーはロック中です。</span><b-button class="is-primary unlockButton" @click="unLock">ロック解除</b-button></td>
              </tr>
            </table>
          </div>
          <div class="card-content margin-top">
            <table>
              <tr><th>【ユーザー情報】</th><td></td></tr>
              <tr><th>ユーザーID</th><td>{{data.userInfo.id}}</td></tr>
              <tr>
                <th>ユーザー名<span class="require" /></th>
                <td>
                  <input class="nameInput validate" type="text" placeholder="姓" v-model="data.userInfo.familyName" name="ユーザー名(姓)"  validate="required" maxlength="50"/>
                  <input class="nameInput validate" type="text" placeholder="名" v-model="data.userInfo.firstName" name="ユーザー名(名)"  validate="required" maxlength="50"/>
                </td>
              </tr>
              <tr>
                <th>ユーザー名(カナ)<span class="require" /></th>
                <td>
                  <input class="nameInput validate" type="text" placeholder="セイ" v-model="data.userInfo.familyNameKana" name="ユーザー名(姓カナ)"  validate="required|kana" maxlength="50"/>
                  <input class="nameInput validate" type="text" placeholder="メイ" v-model="data.userInfo.firstNameKana" name="ユーザー名(名カナ)"  validate="required|kana" maxlength="50"/>
                </td>
              </tr>
              <tr>
                <th>メールアドレス<span class="require" /></th>
                <td>
                  <input type="text" v-model="data.userInfo.mail" class="validate" name="メールアドレス"  validate="required|mail" maxlength="100"/>
                </td>
              </tr>
              <tr>
                <th>メールアドレス(確認)<span class="require" /></th>
                <td><input type="text" v-model="mailAddrcomfirm" class="validate" name="メールアドレス(確認)"  validate="required" maxlength="100"/></td>
              </tr>
              <tr v-if="data.userInfo.mailError"><th></th><td><span class="caution">メールの送信に失敗しています。受信可能なメールアドレスが正しく入力されていることを確認してください。</span></td></tr>
              <tr>
                <th> パスフレーズ認証</th>
                <td>
                  <b-checkbox class="cstmCheckBox" v-model="data.userInfo.passPhrase">二段階認証を行う</b-checkbox>
                </td>
              </tr>
              <tr v-if="data.userInfo.passPhrase">
                <th>パスフレーズ送信先<br>(携帯番号)</th>
                <td>
                  <input type="text" class="withButtonField validate" v-model="data.userInfo.passPhrasePhoneNumber" id="passphraseSendNo" name="パスフレーズ送信先(携帯番号)" validate="numeric" maxlength="20"/>
                  <b-button class="withButton" @click="sendTestSMS">テスト送信</b-button>
                </td>
              </tr>
              <tr v-if="data.userInfo.passPhrase">
                <th>パスフレーズ送信先<br>(Eメールアドレス)</th>
                <td>
                  <input type="text" class="withButtonField validate" v-model="data.userInfo.passPhraseMail" id="passphraseSendMail" name="送信先(Eメールアドレス)" validate="mail" maxlength="256"/>
                  <b-button class="withButton" @click="sendTestMail">テスト送信</b-button>
                </td>
              </tr>
            </table>
          </div>
          <div class="card-content margin-top">
            <table>
              <tr><th>【組織情報】</th> <td></td></tr>
              <tr><th>組織ID</th> <td>{{data.belongInfo.id}}</td></tr>
              <tr><th>種別<span class="require" /></th>
                <td><select v-model="data.belongInfo.role" :disabled="roleId != role.role_admin" class="validate" name="種別"  validate="required" >
                  <option :value="role.role_hospital">医療機関</option>
                  <option :value="role.role_corporation">企業</option>
                  <option :value="role.role_judgment">判定医療機関</option>
                  <option :value="role.role_holter_judgment">ホルター判定医療機関</option>
                  <option :value="role.role_analysis">解析委託業者</option>
                  <option :value="role.role_dealer">ディーラー</option>
                  <option :value="role.role_accommodations">宿泊施設</option></select>
                </td>
              </tr>
              <tr>
                <th>企業名・医療機関名(表示用)<span class="require" /></th>
                <td><input type="text" v-model="data.belongInfo.medicalInstitutionName" class="validate" name="企業名・医療機関名(表示用)" validate="required" maxlength="100"/></td>
              </tr>
              <tr v-if="data.belongInfo.role != role.role_analysis">
                <th>部署名・診療科名(表示用)<span class="require" /></th>
                <td><input type="text" v-model="data.belongInfo.departmentName" maxlength="100" class="validate" name="部署名・診療科名(表示用)" validate="required"/></td>
              </tr>
              <tr>
                <th>郵便番号<span class="require" /></th>
                  <td>
                    <input
                      type="text"
                      class="withButtonField validate"
                      :class="{'border-red': invalidPostcode}"
                      v-model="data.belongInfo.customerPostCode"
                      name="郵便番号"
                      validate="required|numeric"
                      maxlength="7"
                      :placeholder="postcodePlaceholder"
                    />
                  <b-button class="withButton" @click="postCodeSearch">郵便番号検索</b-button>
                  <div v-show="invalidPostcode" class="text-red">{{ invalidNumberMessage }}</div>
                </td>
              </tr>
              <tr>
                <th>都道府県<span class="require" /></th>
                <td>
                  <select v-model="data.belongInfo.prefecture" class="validate" name="都道府県" validate="required">
                      <option value=""/><option value="北海道">北海道</option><option value="青森県">青森県</option><option value="岩手県">岩手県</option><option value="宮城県">宮城県</option><option value="秋田県">秋田県</option><option value="山形県">山形県</option><option value="福島県">福島県</option><option value="茨城県">茨城県</option><option value="栃木県">栃木県</option><option value="群馬県">群馬県</option><option value="埼玉県">埼玉県</option><option value="千葉県">千葉県</option><option value="東京都">東京都</option><option value="神奈川県">神奈川県</option><option value="新潟県">新潟県</option><option value="富山県">富山県</option><option value="石川県">石川県</option><option value="福井県">福井県</option><option value="山梨県">山梨県</option><option value="長野県">長野県</option><option value="岐阜県">岐阜県</option><option value="静岡県">静岡県</option><option value="愛知県">愛知県</option><option value="三重県">三重県</option><option value="滋賀県">滋賀県</option><option value="京都府">京都府</option><option value="大阪府">大阪府</option><option value="兵庫県">兵庫県</option><option value="奈良県">奈良県</option><option value="和歌山県">和歌山県</option><option value="鳥取県">鳥取県</option><option value="島根県">島根県</option><option value="岡山県">岡山県</option><option value="広島県">広島県</option><option value="山口県">山口県</option><option value="徳島県">徳島県</option><option value="香川県">香川県</option><option value="愛媛県">愛媛県</option><option value="高知県">高知県</option><option value="福岡県">福岡県</option><option value="佐賀県">佐賀県</option><option value="長崎県">長崎県</option><option value="熊本県">熊本県</option><option value="大分県">大分県</option><option value="宮崎県">宮崎県</option><option value="鹿児島県">鹿児島県</option><option value="沖縄県">沖縄県</option>
                  </select>
                </td>
              </tr>
              <tr>
                <th>市町村区<span class="require" /></th>
                <td><input type="text" v-model="data.belongInfo.city" class="validate" name="市町村区" validate="required" maxlength="100"/></td>
              </tr>
              <tr>
                <th>住所(丁目、番地)<span class="require"/></th>
                <td><input type="text" v-model="data.belongInfo.customerAddress1" class="validate" name="住所(丁目、番地)" validate="required" maxlength="100"/></td>
              </tr>
              <tr>
                <th>住所(建物名、号室)</th>
                <td><input type="text" v-model="data.belongInfo.customerAddress2" maxlength="100"/></td>
              </tr>
              <tr>
                <th>連絡先(電話番号)<span class="require" /></th>
                <td>
                  <input
                    type="text"
                    v-model="data.belongInfo.phoneNumber"
                    class="validate"
                    :class="{'border-red': invalidPhoneNumber}"
                    name="連絡先"
                    validate="required|numeric"
                    maxlength="11"
                    :placeholder="phonePlaceholder"
                  />
                  <div v-show="invalidPhoneNumber" class="text-red">{{ invalidNumberMessage }}</div>
                </td>
              </tr>
              <template v-if="data.belongInfo.role == role.role_hospital">
                <tr>
                  <th></th>
                  <td>
                    <div>
                      <b-checkbox class="columnCheckBox" v-model="data.belongInfo.agreedInfoDisclosure">転院先施設として住所、連絡先（電話番号・メールアドレス）を公開する</b-checkbox>
                    </div>
                  </td>
                </tr>
                <template v-if="data.belongInfo.agreedInfoDisclosure">
                  <tr>
                    <th>連絡先メールアドレス<span class="require" /></th>
                    <td>
                      <input type="text" v-model="data.belongInfo.publicMail" class="withButtonField validate" id="publicMail" name="連絡先メールアドレス"  validate="required|mail" maxlength="256"/>
                      <b-button class="withButton" @click="sendTestPublicAddressMail">テスト送信</b-button>
                    </td>
                  </tr>
                </template>
              </template>
              <tr>
                <th style="vertical-align:top;">コメント</th>
                <td>
                  <textarea v-model="data.belongInfo.note" maxlength="256" style="resize:vertical;max-width:100%;height:100px;"></textarea>
                </td>
              </tr>
            </table>
          </div>
          <template v-if="data.belongInfo.role != role.role_judgment && data.belongInfo.role != role.role_holter_judgment && data.belongInfo.role != role.role_analysis">
            <template v-if="(data.belongInfo.role==role.role_hospital || data.belongInfo.role==role.role_dealer) && data.userInfo.status==extUserStatus.tempReg && !belongsSelected">
              <div class="card-content margin-top">
                <span v-if="data.userInfo.status == 1" style="font-size: 30px; color:red;">※こちらは本社入力欄です。支店での操作は行わないでください。<br></span>
                <div class="card-content margin-top">
                  <div>
                    <span class="requireHeadOffice"/>
                    <span style="font-size: 20px;">　　　組織情報を検索してください。</span>
                  </div>
                  <div style="margin-top:15px;">
                      <span>得意先コード：</span><input type="text" style="width:300px;" v-model="searchCondition.belongsCustomerCode"/>
                      <span style="margin-left:10px;">組織名：</span><input type="text" style="width:300px;" v-model="searchCondition.belongsName"/>
                  </div>
                  <div style="margin-top:15px;">
                    <b-button  class="is-primary withButton" v-on:click="searchBelongList" >組織検索</b-button>
                  </div>
                  <div class="result-area" style="margin-left:10px;margin-right: 10px;">
                    <b-table v-if="belongsList.length > 0"
                      id="belongListTable"
                      :data="belongsList"
                      paginated
                      per-page="20"
                      pagination-position="both"
                      aria-next-label="Next page"
                      aria-previous-label="Previous page"
                      aria-page-label="Page"
                      aria-current-label="Current page"
                    >
                      <template slot-scope="props">
                        <b-table-column field="customerId" label="" width="20" centered>
                          <div>
                            <b-radio class="customRadio" name="radioItem" v-model="selectedNewBelongs" :native-value="props.row"></b-radio>
                          </div>
                        </b-table-column>
                        <b-table-column field="customerId" label="得意先コード" width="150" centered>{{props.row.customerId }}</b-table-column>
                        <b-table-column field="customerName" label="組織名" width="500" >{{props.row.medicalInstitutionFullName}}</b-table-column>
                        <b-table-column field="branchCode" label="担当支店" width="170" >{{props.row.branchCode | branchFilter(branchOfficeMaster)}}</b-table-column>
                        <b-table-column field="address" label="住所"  width="600" >{{props.row.address}}</b-table-column>
                      </template>
                    </b-table>
                  </div>
                </div>
                <div class="margin-top">
                  <b-button  class="is-primary belongsSlectedBtn" v-on:click="changeBelongsId" :disabled="selectedNewBelongs==null" >選択した組織情報を使用して登録を続ける</b-button>
                  <span style="padding-left:10px;padding-right:10px;"/>
                  <b-button  class="is-primary belongsSlectedBtn" v-on:click="noChangeBelongsId" >リストに存在しないため、新しい組織として登録する</b-button>
                </div>

              </div>
            </template>
            <template v-else>
              <div class="card-content margin-top">
                <table>
                  <tr><th>【システム連携情報】</th> <td></td></tr>
                  <tr><th> 得意先情報<span class="requireHeadOffice"/></th>
                    <td>
                      得意先ID:<input type="text" disabled style="width:150px;" v-model="data.belongInfo.customerId"/>
                      得意先名称:<input type="text" disabled style="width:460px;" v-model="data.belongInfo.customerName"/>
                      <b-button  class="is-primary withButton" v-on:click="customerModalActive=true" >得意先選択</b-button>
                    </td>
                  </tr>
                  <tr>
                    <th></th>
                    <td>担当支店:
                        <select style="width:250px;" v-model="data.belongInfo.branchStore">
                          <option v-for="branch of branchOfficeMaster" :value="branch.code" :key="'d' + branch.code">
                            {{branch.name}}
                          </option>
                        </select>
                    </td>
                  </tr>
                  <tr/>
                  <tr><th>営業担当<span class="requireBrunch"/></th>
                    <td>
                      担当者名:<input type="text" style="width:150px;" v-model="data.belongInfo.salesStaffName" disabled/>
                      メールアドレス:<input type="text" style="width:430px;" v-model="data.belongInfo.salesStaffAddress" disabled/>
                      <b-button  class="is-primary withButton" v-on:click="staffModalActive=true" >担当者選択</b-button>
                    </td>
                  </tr>
                  <tr><th> </th>
                    <td>担当営業所(売上):
                        <select style="width:250px;" v-model="data.belongInfo.salesOfficeCode">
                          <option v-for="office of salesOfficeMaster" :value="office.code" :key="'s' + office.code">
                            {{office.name}}
                          </option>
                        </select>
                    </td>
                  </tr>
                  <tr/>

                  <template v-if="data.belongInfo.role == role.role_hospital">
                    <tr><th><span :class="disabledInspectionReport('requireBrunch')">SMS医療機関情報</span></th>
                      <td>
                        <span :class="disabledInspectionReport()">医療機関コード:</span><input type="text" disabled style="width:150px;" v-model="data.belongInfo.smsHospitalCode"/>
                        <span :class="disabledInspectionReport()">医療機関名称:</span><input type="text" disabled style="width:400px;" v-model="data.belongInfo.smsHospitalName"/>
                        <b-button  class="is-primary withButton" :disabled="this.useInspectionReport ? false : true" v-on:click="smsHospitalModalActive=true" >医療機関選択</b-button>
                      </td>
                    </tr>
                    <tr><th> </th>
                      <td><span :class="disabledInspectionReport()">※利用サービスに呼吸点検報告書を含む場合は指定してください</span></td>
                    </tr>
                    <tr/>
                  </template>

                  <template v-if="data.belongInfo.role == role.role_hospital || data.belongInfo.role == role.role_dealer">
                    <tr><th>巻き取り対象<span class="requireHeadOffice"/></th>
                      <td>
                        <select style="width:200px" v-model="data.belongInfo.takeupStatus">
                          <option value=0></option>
                          <option value=1>本社</option>
                          <option value=2>支店</option>
                        </select>
                      </td>
                    </tr>
                    <tr/>
                  </template>
                  <template v-if="billingEnabled">
                    <tr><th>検査解析請求先情報<span class="requireHeadOffice"/></th>
                      <td>
                        請求先ID:<input type="text" style="width:150px;" v-model="data.belongInfo.billingId" disabled/>
                        請求先名称:<input type="text" style="width:460px;" v-model="data.belongInfo.billingName" disabled/>
                        <b-button  class="is-primary withButton" v-on:click="billModalActive=true" >請求先選択</b-button>
                      </td>
                    </tr>
                    <tr><th> </th>
                      <td>※得意先IDと異なるコードに売上を計上する場合は指定してください</td>
                    </tr>
                  </template>
                  <template v-else>
                    <tr><th><span class="disabled">検査解析請求先情報</span><span class="requireHeadOffice disabled"/></th>
                      <td>
                        <span class="disabled">請求先ID:</span><input type="text" style="width:150px;" v-model="data.belongInfo.billingId" disabled/>
                        <span class="disabled">請求先名称:</span><input type="text" style="width:460px;" v-model="data.belongInfo.billingName" disabled/>
                        <b-button  class="is-primary withButton" disabled>請求先選択</b-button>
                      </td>
                    </tr>
                    <tr><th> </th>
                      <td><span class="disabled">※得意先IDと異なるコードに売上を計上する場合は指定してください</span></td>
                    </tr>
                  </template>
                  <template v-if="data.belongInfo.role == role.role_hospital || data.belongInfo.role == role.role_dealer">
                    <tr></tr>
                    <tr>
                        <th>利用サービス</th>
                        <td>
                          <div>
                            <b-checkbox class="columnCheckBox" v-model="useHst" @input="changeCheckBox()" >睡眠検査機器配送ｻｰﾋﾞｽ</b-checkbox>
                            <b-checkbox class="columnCheckBox" v-model="usePsg" @input="changeCheckBox()" >PSG解析</b-checkbox>
                            <b-checkbox class="columnCheckBox" v-model="useKenshin" @input="changeCheckBox()" >企業検診</b-checkbox>
                            <b-checkbox class="columnCheckBox" v-model="useHolter" @input="changeCheckBox()" >ホルター心電図配送ｻｰﾋﾞｽ</b-checkbox>
                            <b-checkbox class="columnCheckBox" v-model="useCPAP" @input="changeCheckBox()" >CPAP指示書登録サービス</b-checkbox>
                            <b-checkbox class="columnCheckBox" :value="true" disabled >ケア オーケストレーター</b-checkbox>
                            <b-checkbox v-if="data.belongInfo.role == role.role_hospital" class="columnCheckBox" v-model="useInspectionReport" @input="changeCheckBox()" >呼吸点検報告書</b-checkbox>
                          </div>
                        </td>
                    </tr>
                    <tr>
                      <th></th>
                      <td><span>※選択したサービスがユーザーのホーム画面に表示されます。</span></td>
                    </tr>
                    <template v-if="data.belongInfo.role == role.role_hospital  && (useHst || usePsg || useKenshin || useHolter || useHolterAnalysis || useCPAP)">
                      <tr/>
                      <tr>
                        <th>ディーラーフォロー<span class="requireBrunch"/></th>
                        <td>
                          <div>
                            <b-checkbox class="columnCheckBox" v-model="data.belongInfo.dealerFollowFlg" >医療機関が依頼した際にディーラー担当者へメールを送信する</b-checkbox>
                          </div>
                          <div style="color:red;">※CPAPの処方のみ</div>
                        </td>
                      </tr>
                      <tr v-if="data.belongInfo.dealerFollowFlg">
                        <th></th>
                        <td>
                          <div>
                            ディーラー担当者メールアドレス:
                            <input type="text" v-model="data.belongInfo.dealerFollowMail" class="validate" id="dealerFollowMail" style="width:525px;" name="ディーラー担当者メールアドレス"  validate="mail" maxlength="256"/>
                            <b-button class="withButton" @click="sendTestDealerFollowMail">テスト送信</b-button>
                          </div>
                        </td>
                      </tr>
                    </template>
                    <template v-if="useHolter">
                      <tr></tr>
                      <tr>
                        <th>ホルター心電図配送サービス<br>利用設定<span class="requireBrunch"/></th>
                        <td>
                          <b-checkbox class="columnCheckBox" style="width:100%!important" v-model="data.belongInfo.holterDepositSignedFlg" @input="changeHolterDepositSignedCheckBox()" >顧客とのホルター心電図院内貸出の契約が完了している</b-checkbox>
                          <b-checkbox class="columnCheckBox" :disabled="!data.belongInfo.holterDepositSignedFlg" v-model="data.belongInfo.holterUseDepositFlg" >ホルター心電図院内貸出を実施する</b-checkbox>
                        </td>
                      </tr>
                    </template>
                    <template v-if="useCPAP">
                    <tr></tr>
                      <tr>
                        <th>CPAP利用設定<span class="requireBrunch"/></th>
                        <td>
                          請求先コード:<input type="text" disabled style="width:150px;" v-model="data.belongInfo.cpapBillingCode"/>
                          請求先名称:<input type="text" disabled style="width:430px;" v-model="data.belongInfo.cpapBillingName"/>
                          <b-button  class="is-primary withButton" v-on:click="cpapBillingModalActive=true" >請求先選択</b-button>
                          <br>※得意先IDと同じ場合は入力不要です。
                        </td>
                      </tr>
                      <tr>
                        <th></th>
                        <td>
                          <div>
                            <b-checkbox class="columnCheckBox" v-model="data.belongInfo.cpapSignedFlg " >医療機関もしくはディーラーとのCPAP利用契約が完了している</b-checkbox>
                          </div>
                        </td>
                      </tr>
                      <template v-if="data.belongInfo.role == role.role_dealer">
                        <tr>
                          <th></th>
                          <td>
                            <div>
                                <b-radio class="td_radio" name="cpapDealerRentalFlg"  v-model="cpapDealerRentalFlg" native-value="false">患者情報を管理する</b-radio>
                                <b-radio class="td_radio" name="cpapDealerRentalFlg"  v-model="cpapDealerRentalFlg" native-value="true">患者情報を管理しない（機器レンタルのみ）</b-radio>
                            </div>
                          </td>
                        </tr>
                      </template>
                      <tr>
                        <th></th>
                        <td>
                          <div>
                            使用明細確認者メールアドレス:
                            <input type="text" v-model="data.belongInfo.cpapUsageDetailMail" class="validate" id="cpapUsageDetailMail" style="width:540px;" name="使用明細確認者メールアドレス"  validate="mail" maxlength="256"/>
                            <b-button class="withButton" @click="sendTestCpapUsageDetailMail">テスト送信</b-button>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th></th>
                        <td>
                          <div>
                            <b-checkbox class="columnCheckBox" v-model="data.belongInfo.cpapUsageDetailBehalf" >使用明細を支店から発行（FAX・持参等）する(使用明細確認を支店で代理する)</b-checkbox>
                          </div>
                        </td>
                      </tr>
                    </template>
                  </template>
                  <template v-if="data.belongInfo.role == role.role_hospital || data.belongInfo.role == role.role_dealer">
                    <tr></tr>
                    <tr>
                      <th>ケアオケ利用状況</th>
                      <td>
                        <template v-if="data.belongInfo.coInUse==coUse.notUse">未利用</template>
                        <template v-else-if="data.belongInfo.coInUse==coUse.waitting">申請待ち</template>
                        <template v-else-if="data.belongInfo.coInUse==coUse.inUse">利用中</template>
                        <template v-else-if="data.belongInfo.coInUse==coUse.registed">登録待ち
                          <b-button class="is-primary coImportButton" @click="coImportModalActive=true">施設情報のインポート</b-button>
                        </template>
                      </td>
                    </tr>
                  </template>
                  <tr></tr>
                  <template v-for="(itemInfo, index) in data.inspectionItemInfo">
                    <tr :key="index">
                      <th>
                        <template v-if="index==0">見積り情報<span class="requireBrunch"/></template>
                        <template v-if="index==1 && data.belongInfo.role==role.role_dealer">
                            <b-button  class="is-primary withButton" @click="goFacilitySetting" >施設別設定</b-button>
                            <span v-if="data.facilityError" class="facilityError"/>
                        </template>
                      </th>
                      <td>
                        品目コード：<input type="text" style="width:100px;" v-model="itemInfo.itemCode" disabled/>
                        品目名：<input type="text" style="width:410px;" v-model="itemInfo.itemName" disabled/>
                        見積りコード：<input type="text" style="width:150px;" v-model="itemInfo.estimateCode" maxlength="20"/>
                      </td>
                    </tr>
                  </template>
                </table>
              </div>
            </template>
          </template>
          <div class="card-content margin-top">
            <tr>
              <th>【ポータル公開設定情報】</th><td></td></tr>
            <tr>
              <th style="width: 220px">
                情報ポータル公開範囲<span class="requireBrunch" />
              </th>
              <td>
                <b-checkbox
                  class="columnCheckBox"
                  v-model="isEnabledNotice"
                  disabled
                  >お知らせ</b-checkbox
                >
                <b-checkbox
                  class="columnCheckBox"
                  v-model="isEnabledGuidance"
                  :disabled="isDisablePortalItem()"
                  >ご案内</b-checkbox
                >
                <b-checkbox
                  class="columnCheckBox"
                  v-model="isEnabledEvent"
                  :disabled="isDisablePortalItem()"
                  >学会・イベント情報</b-checkbox
                >
                <b-checkbox
                  class="columnCheckBox"
                  v-model="isEnabledNews"
                  >ニュース</b-checkbox
                >
                <b-checkbox
                  class="columnCheckBox"
                  v-model="isEnabledProduct"
                  :disabled="isDisablePortalItem()"
                  >製品情報</b-checkbox
                >
              </td>
            </tr>
            <tr>
              <th style="width: 220px">
                定期メール送信設定<span class="requireBrunch" />
              </th>
              <td>
                <b-checkbox
                  class="columnCheckBox"
                  @input="changeCheckBox()"
                  v-model="isEnabledMail"
                  >定期メールを送信する</b-checkbox
                >
              </td>
            </tr>
          </div>
          <div class="searchButton-area" style="margin-bottom:10px;">
            <template v-if="data.userInfo.status==extUserStatus.registed">
              <!--本登録中 -->
              <b-button class="is-primary" v-on:click="update">更新</b-button>
              <b-button class="is-primary" v-on:click="del">削除</b-button>
            </template>
            <template v-else-if="data.userInfo.status==extUserStatus.brunchReview">
              <!--支店回送中 -->
              <b-button class="is-primary" v-on:click="regist">本登録</b-button>
              <b-button class="is-primary" v-on:click="del">削除</b-button>
            </template>
            <template v-else-if="data.userInfo.status==extUserStatus.tempReg">
              <!--仮登録中 -->
              <template v-if="data.belongInfo.role==role.role_hospital || data.belongInfo.role==role.role_dealer">
                <template v-if="belongsSelected">
                  <template v-if="roleId==role.role_headOffice || roleId==role.role_admin">
                    <b-button class="is-primary" v-on:click="sendSalesOffice">担当部署へ回送</b-button>
                  </template>
                  <template v-if="roleId==role.role_admin">
                    <b-button class="is-primary" v-on:click="regist">本登録</b-button>
                  </template>
                </template>
              </template>
              <template v-else-if="data.belongInfo.role==role.role_corporation">
                <b-button class="is-primary" v-on:click="sendSalesOffice">担当部署へ回送</b-button>
              </template>
              <template v-else>
                <b-button class="is-primary" v-on:click="regist">本登録</b-button>
              </template>
            </template>
            <template v-else-if="data.userInfo.status==extUserStatus.addRequest">
              <!--追加依頼中 -->
              <template v-if="roleId==role.role_headOffice || roleId==role.role_admin">
                <!--本社、管理者ユーザのみ本登録可能 -->
                <b-button class="is-primary" v-on:click="regist">本登録</b-button>
              </template>
              <!-- <b-button class="is-primary" v-on:click="del">削除</b-button> -->
            </template>
            <b-button class="backButton is-primary" v-on:click="back">戻る</b-button>
          </div>
        </div>
      </div>
    </div>
    <b-modal :active.sync="customerModalActive" has-modal-card>
      <customerModal @select="setCustomer"></customerModal>
    </b-modal>
    <b-modal :active.sync="cpapBillingModalActive" has-modal-card>
      <customerModal @select="setCpapBilling" :allowBlank="true"></customerModal>
    </b-modal>
    <b-modal :active.sync="staffModalActive" has-modal-card>
      <staffModal @select="setStaff" :selectRole="[]" ></staffModal>
    </b-modal>
    <b-modal :active.sync="billModalActive" has-modal-card>
      <customerModal @select="setBill" :allowBlank="true"></customerModal>
    </b-modal>
    <b-modal :active.sync="coImportModalActive" has-modal-card>
      <coImportModal @reload="reload" :isDealer="data.belongInfo.role == role.role_dealer" :belongId="data.belongInfo.id"></coImportModal>
    </b-modal>
    <b-modal :active.sync="smsHospitalModalActive" has-modal-card>
      <smsHospitalModal @select="setSmsHospital"></smsHospitalModal>
    </b-modal>
  </div>
</template>

<script>
import {
  role,
  service,
  extUserStatus,
  coUse,
  invalidNumberMessage,
  postcodePlaceholder,
  phonePlaceholder
} from "@/components/mock/base/const.js";
import naviBar from "@/components/mock/philips/master/MasterMaintenanceBar";
import userNaviBar from "@/components/mock/philips/master/user/UserNavi";
import CustomerSelectModal from "@/components/mock/philips/common/CustomerSelectModal";
import StaffSelectModal from "@/components/mock/philips/common/StaffSelectModal";
import coImportModal from "@/components/mock/philips/common/CoImportModal";
import SmsHospitalSelectModal from "@/components/mock/philips/common/SmsHospitalSelectModal";

export default {
  name: "ExternalUserEdit",
  methods: {
    unLock: function() {
      // Web Api Call
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.apiCommon.userUnlockPOST({
            body:{
              userId: _this.data.userInfo.id
            }
          });
        },
        async function(result){
          _this.showSuccess(result);
          //再読み込み
          await _this.getExternalUserDetail();
        },
        function(result){
          _this.showErrorMessage(result);
        }
      ); 
    },
    back: function() {
      if(this.from =='control'){
        this.$router.push({
          name: "ExternalUserControlSearch",
          params: {searchConditions: this.searchConditions}
        });
      } else {
        this.$router.push({
          name: "ExternalUserSearch",
          params: {searchConditions: this.searchConditions}
        });
      }
    },
    sendTestSMS: function(){
        if(this.data.userInfo.passPhrasePhoneNumber != ""){
            var checkFields = [document.getElementById("passphraseSendNo")];
            var result = this.selfMadeValidation(checkFields)
            if(result.msg == ""){
                this.sendTest({
                    passphraseSendMail:"",
                    passphraseSendNo:this.data.userInfo.passPhrasePhoneNumber
                });
            } else {
                this.showErrorMessage(result.msg)
            }
        } else {
            this.showErrorMessage("パスフレーズ送信先(携帯番号)を入力してください。")
        }
    },
    sendTestMail: function(){
        if(this.data.userInfo.passPhraseMail != ""){
            var checkFields = [document.getElementById("passphraseSendMail")];
            var result = this.selfMadeValidation(checkFields)
            if(result.msg == ""){
                this.sendTest({
                  passphraseSendMail:this.data.userInfo.passPhraseMail,
                  passphraseSendNo:""
                });
            } else {
                this.showErrorMessage(result.msg)
            }
        } else {
            this.showErrorMessage("パスフレーズ送信先(Eメールアドレス)を入力してください。")
        }
    },
    sendTestPublicAddressMail: function(){
        if(this.data.belongInfo.publicMail != ""){
            var checkFields = [document.getElementById("publicMail")];
            var result = this.selfMadeValidation(checkFields)
            if(result.msg == ""){
                this.sendTest({
                  passphraseSendMail:this.data.belongInfo.publicMail,
                  passphraseSendNo:""
                });
            } else {
                this.showErrorMessage(result.msg)
            }
        } else {
          this.showErrorMessage("連絡先メールアドレスを入力してください。")
        }
    },
    sendTestCpapUsageDetailMail: function(){
        if(this.data.belongInfo.cpapUsageDetailMail != ""){
            var checkFields = [document.getElementById("cpapUsageDetailMail")];
            var result = this.selfMadeValidation(checkFields)
            if(result.msg == ""){
                this.sendTest({
                  passphraseSendMail:this.data.belongInfo.cpapUsageDetailMail,
                  passphraseSendNo:""
                });
            } else {
                this.showErrorMessage(result.msg)
            }
        } else {
            this.showErrorMessage("使用明細確認者メールアドレスを入力してください。")
        }
    },
    sendTestDealerFollowMail: function(){
        if(this.data.belongInfo.dealerFollowMail != ""){
            var checkFields = [document.getElementById("dealerFollowMail")];
            var result = this.selfMadeValidation(checkFields)
            if(result.msg == ""){
                this.sendTest({
                  passphraseSendMail:this.data.belongInfo.dealerFollowMail,
                  passphraseSendNo:""
                });
            } else {
                this.showErrorMessage(result.msg)
            }
        } else {
            this.showErrorMessage("ディーラー担当者メールアドレスを入力してください。")
        }
    },
    sendTest: function(param){
      try {
          this.$store.dispatch("sendTest", {
            token: this.token,
            contactAddress: param.passphraseSendMail,
            contactPhoneNumber: param.passphraseSendNo
          }).then(result => {
              console.log(result);
              if(result != null && result.status === 200 ) {
                  this.showMessage("メッセージを送信しました。<br>指定した宛先にメッセージが届いていることを確認してください。") 
              } else {
                  this.showErrorMessage(result.message) 
              }
              this.isActive = true;
          }).catch(error => {
              console.log(error);
              this.showErrorMessage("予期しないエラーが発生しました。")
          });
      } catch(err){
          console.log(error);
          this.showErrorMessage("予期しないエラーが発生しました。")
      }
    },
    createBody: function(){
      let userInfo = {
                id: this.data.userInfo.id ? this.data.userInfo.id:0,
                familyName: this.data.userInfo.familyName ? this.data.userInfo.familyName:"",
                firstName: this.data.userInfo.firstName ? this.data.userInfo.firstName:"",
                familyNameKana: this.data.userInfo.familyNameKana ? this.data.userInfo.familyNameKana:"",
                firstNameKana: this.data.userInfo.firstNameKana ? this.data.userInfo.firstNameKana:"",
                mail: this.data.userInfo.mail ? this.data.userInfo.mail:"",
                passPhrase: this.data.userInfo.passPhrase ? this.data.userInfo.passPhrase:false,
                passPhrasePhoneNumber: this.data.userInfo.passPhrasePhoneNumber ? this.data.userInfo.passPhrasePhoneNumber:"",
                passPhraseMail: this.data.userInfo.passPhraseMail ? this.data.userInfo.passPhraseMail:"",
                mailError: this.data.userInfo.mailError ? this.data.userInfo.mailError:false,
                lock: this.data.userInfo.lock ? this.data.userInfo.lock:false,
                status: this.data.userInfo.status ? this.data.userInfo.status:"0",
              };
      let belongInfo = {
                id: this.data.belongInfo.id ? this.data.belongInfo.id:0,
                role: this.data.belongInfo.role ? this.data.belongInfo.role:0,
                medicalInstitutionName: this.data.belongInfo.medicalInstitutionName ? this.data.belongInfo.medicalInstitutionName:"",
                departmentName:  this.data.belongInfo.departmentName ? this.data.belongInfo.departmentName:"",
                customerPostCode:  this.data.belongInfo.customerPostCode ? this.data.belongInfo.customerPostCode:"",
                prefecture:  this.data.belongInfo.prefecture ? this.data.belongInfo.prefecture:"",
                city:  this.data.belongInfo.city ? this.data.belongInfo.city:"",
                customerAddress1:  this.data.belongInfo.customerAddress1 ? this.data.belongInfo.customerAddress1:"",
                customerAddress2:  this.data.belongInfo.customerAddress2 ? this.data.belongInfo.customerAddress2:"",
                phoneNumber:  this.data.belongInfo.phoneNumber ? this.data.belongInfo.phoneNumber:"",
                mail:  this.data.belongInfo.mail ? this.data.belongInfo.mail:"",
                customerId:  this.data.belongInfo.customerId ? this.data.belongInfo.customerId:"",
                customerName:  this.data.belongInfo.customerName ? this.data.belongInfo.customerName:"",
                branchStore:  this.data.belongInfo.branchStore ? this.data.belongInfo.branchStore:"",
                salesStaffId:  this.data.belongInfo.salesStaffId ? this.data.belongInfo.salesStaffId:0,
                salesStaffName:  this.data.belongInfo.salesStaffName ? this.data.belongInfo.salesStaffName:"",
                salesStaffAddress:  this.data.belongInfo.salesStaffAddress ? this.data.belongInfo.salesStaffAddress:"",
                salesOfficeCode:  this.data.belongInfo.salesOfficeCode ? this.data.belongInfo.salesOfficeCode:"",
                billingId:  this.data.belongInfo.billingId ? this.data.belongInfo.billingId:"",
                useService:  this.data.belongInfo.useService ? this.data.belongInfo.useService:0,
                publicMail:  this.data.belongInfo.publicMail ? this.data.belongInfo.publicMail:"",
                agreedInfoDisclosure:  this.data.belongInfo.agreedInfoDisclosure ? this.data.belongInfo.agreedInfoDisclosure:false,
                facilityError:  this.data.belongInfo.facilityError ? this.data.belongInfo.facilityError:false,
                note:  this.data.belongInfo.note ? this.data.belongInfo.note : "",
                dealerFollowFlg:  this.data.belongInfo.dealerFollowFlg ? this.data.belongInfo.dealerFollowFlg:false,
                dealerFollowMail: this.data.belongInfo.dealerFollowMail ? this.data.belongInfo.dealerFollowMail : "",
                cpapSignedFlg: this.data.belongInfo.cpapSignedFlg ? this.data.belongInfo.cpapSignedFlg:false,
                cpapDealerRentalFlg: this.cpapDealerRentalFlg != null ? this.cpapDealerRentalFlg == "true" :false,
                cpapUsageDetailMail:  this.data.belongInfo.cpapUsageDetailMail ? this.data.belongInfo.cpapUsageDetailMail:"",
                cpapUsageDetailBehalf: this.data.belongInfo.cpapUsageDetailBehalf ? this.data.belongInfo.cpapUsageDetailBehalf:false,
                cpapBillingCode:  this.data.belongInfo.cpapBillingCode ? this.data.belongInfo.cpapBillingCode:"",
                coUseStatus: this.data.belongInfo.coInUse ? this.data.belongInfo.coInUse:0,
                holterDepositSignedFlg: this.data.belongInfo.holterDepositSignedFlg ? this.data.belongInfo.holterDepositSignedFlg:false,
                holterUseDepositFlg: this.data.belongInfo.holterUseDepositFlg ? this.data.belongInfo.holterUseDepositFlg:false,
                smsHospitalCode: this.useInspectionReport && this.data.belongInfo.smsHospitalCode ? this.data.belongInfo.smsHospitalCode:"",
                takeupStatus: this.data.belongInfo.takeupStatus ? this.data.belongInfo.takeupStatus:0,
              };
      let inspectionItemInfo = [];
      for(let inspectionItem of this.data.inspectionItemInfo){
        inspectionItemInfo.push(
          {
            estimateId: inspectionItem.estimateId ? inspectionItem.estimateId : 0,
            itemCode: inspectionItem.itemCode ? inspectionItem.itemCode : "",
            itemName: inspectionItem.itemName ? inspectionItem.itemName : "",
            estimateCode: inspectionItem.estimateCode ? inspectionItem.estimateCode : "",
          }
        );
      }
      let portalPublicationRangeSettingInfo = {
        isEnabledNotice: this.isEnabledNotice,
        isEnabledGuidance: this.isEnabledGuidance,
        isEnabledEvent: this.isEnabledEvent,
        isEnabledNews: this.isEnabledNews,
        isEnabledProduct: this.isEnabledProduct,
        isEnabledMail: this.isEnabledMail,
      };
      return {
        userInfo:userInfo,
        belongInfo:belongInfo,
        inspectionItemInfo:inspectionItemInfo,
        portalPublicationRangeSettingInfo: portalPublicationRangeSettingInfo,
      }
    },
    update: async function() {
      var elements = document.getElementsByClassName("validate")
      var result = this.selfMadeValidation(elements)
      var errMsg = result.msg
      if(result.isError){
        this.showErrorMessage(errMsg)
      }else if (errMsg != ""){
        this.showErrorMessage(errMsg)
      }else{
        if(await this.inputCheck(true)){
          // Web Api Call
          var _this = this;
          var body = this.createBody();
          this.apiCall(
            function(client){
              return client.apis.internalMaintenance.setMaintenanceExternalUserUpdatePOST({
                body:body
              });
            },
            async function(result){
              _this.showSuccess(result);
              //再読み込み
              await _this.getExternalUserDetail();
            },
            function(result){
              _this.showErrorMessage(result);
            }
          );
        }
      }
    },
    sendSalesOffice: async function(){
      var elements = document.getElementsByClassName("validate")
      var result = this.selfMadeValidation(elements)
      var errMsg = result.msg
      if(result.isError){
        this.showErrorMessage(errMsg)
      }else if (errMsg != ""){
        this.showErrorMessage(errMsg)
      }else{
        if(await this.inputCheck(false)){
          // Web Api Call
          var _this = this;
          var body = this.createBody();
          this.apiCall(
            function(client){
              return client.apis.internalMaintenance.setMaintenanceExternalUserBranchForwardPOST({
                body:body
              });
            },
            async function(result){
              _this.showSuccess(result, function(){
                //前画面に戻る
                _this.back();
              });
            },
            function(result){
              _this.showErrorMessage(result);
            }
          ); 
        }
      }
    },
    regist: async function() {
      var elements = document.getElementsByClassName("validate")
      var result = this.selfMadeValidation(elements)
      var errMsg = result.msg
      if(result.isError){
        this.showErrorMessage(errMsg)
      }else if (errMsg != ""){
        this.showErrorMessage(errMsg)
      }else{
        if(await this.inputCheck(true)){
          // Web Api Call
          var _this = this;
          var body = this.createBody();
          this.apiCall(
            function(client){
              return client.apis.internalMaintenance.setMaintenanceExternalUserRegistrationPOST({
                body:body
              });
            },
            async function(result){
              _this.showSuccess(result, function(){
                //前画面に戻る
                _this.back();
              });
            },
            function(result){
              _this.showErrorMessage(result);
            }
          ); 
        }
      }
    },
    //特殊な入力チェック
    inputCheck: async function(doSalesCheck){
      if(this.data.userInfo.mail != this.mailAddrcomfirm){
        this.showErrorMessage("メールアドレス(確認)が一致しません。");
        return false;
      }
      if(this.data.userInfo.passPhrase){
        if(!this.data.userInfo.passPhrasePhoneNumber && !this.data.userInfo.passPhraseMail){
          this.showErrorMessage("パスフレーズ送信先(携帯番号)または、パスフレーズ送信先(Eメールアドレス)のどちらかを入力してください。");
          return false;
        }
      }
      if(this.data.belongInfo.role != this.role.role_judgment && this.data.belongInfo.role != this.role.role_holter_judgment && this.data.belongInfo.role != this.role.role_analysis){
        if(!this.data.belongInfo.customerId){
          this.showErrorMessage("得意先を設定してください。");
          return false;
        }
        if(!this.data.belongInfo.branchStore){
          this.showErrorMessage("担当支店を設定してください。");
          return false;
        }
        if(doSalesCheck){
          //本登録、更新の場合
          if(!this.data.belongInfo.salesStaffId){
            this.showErrorMessage("営業担当者を設定してください。");
            return false;
          }
          if(!this.data.belongInfo.salesOfficeCode){
            this.showErrorMessage("担当営業所を設定してください。");
            return false;
          }
          //ディーラーフォロー
          if(this.data.belongInfo.dealerFollowFlg){
            if(this.data.belongInfo.dealerFollowMail == ""){
              this.showErrorMessage("ディーラー担当者メールアドレスを設定してください。");
              return false;
            }
          }
          //利用サービスにCPAPが含まれている場合
          if(this.isEnableService(this.data.belongInfo.useService, this.service.cpap)){
            if(!this.data.belongInfo.cpapSignedFlg){
              this.showErrorMessage("CPAP利用契約が完了していることを確認してください。");
              return false;
            }
            if(this.data.belongInfo.cpapUsageDetailMail == ""){
              this.showErrorMessage("使用明細確認者メールアドレスを設定してください。");
              return false;
            }
          } else {
            //CPAP利用しない場合は設定を削除する
            this.data.belongInfo.cpapBillingCode = "";
            this.data.belongInfo.cpapSignedFlg = false;
            this.data.belongInfo.cpapUsageDetailBehalf = false;
          }

          if(this.useInspectionReport){
            if(!this.customer) {
              this.showErrorMessage("得意先情報を取得できませんでした。");
              return false;
            }
            if(!this.data.belongInfo.smsHospitalCode) {
              this.showErrorMessage("SMS医療機関を設定してください。");
              return false;
            }

            const messageDetails = [];
            const pcpPhonNumber = this.customer.phoneNumber.replace(/(-)/g, '');
            const smsPhonNumber = this.smsHospital.phoneNumber.replace(/(-)/g, '');
            const pcpPostCode = this.customer.postCode.replace(/(-)/g, '');
            const smsPostCode = this.smsHospital.postCode.replace(/(-)/g, '');
            const pcpAddress = this.customer.address.replace(/( |　)/g, '');
            const smsAddress = this.smsHospital.address.replace(/( |　)/g, '');
            if (pcpPhonNumber != smsPhonNumber) {
              messageDetails.push("<li>電話番号</li>");
            }
            if (pcpPostCode != smsPostCode) {
              messageDetails.push("<li>郵便番号</li>");
            }
            if (pcpAddress != smsAddress) {
              messageDetails.push("<li>住所</li>");
            }

            if (messageDetails.length) {
              let message = "PCPとSMSの医療機関で、以下の情報に差異があるため医療機関の紐づけを行えません。\n";
              message += "呼吸点検報告書サービスが利用できませんが、処理を継続しますか？\n";
              message += messageDetails.join("");
              const confiermRes = await this.showComfirmMessage(message);
              if (confiermRes) {
                this.data.belongInfo.smsHospitalCode = null;
                this.data.belongInfo.smsHospitalName = null;
                this.smsHospital = null;
              } else {
                return false;
              }
            }
          }
        }
      }
      return true;
    },
    del: function() {
      var _this = this;
      this.$dialog.confirm({
        title: "　",
        message: "ユーザーを削除しますか？",
        cancelText: "キャンセル",
        onConfirm: async () => {
          // Web Api Call
          _this.apiCall(
            function(client){
              return client.apis.internalMaintenance.setMaintenanceExternalUserDeletePOST({
                body:{
                  userId: _this.data.userInfo.id 
                }
              });
            },
            async function(result){
              _this.showSuccess(result, function(){
                //前画面に戻る
                _this.back();
              });
            },
            function(result){
              _this.showErrorMessage(result);
            }
          ); 
        }
      });
    },
    setCustomer: function(customerInfo){
      if(customerInfo){
        this.customer = customerInfo;
        this.data.belongInfo.customerId = customerInfo.customerId;
        this.data.belongInfo.customerName = customerInfo.customerName;
        if(this.data.userInfo.status!=extUserStatus.registed && this.data.userInfo.status!=extUserStatus.addRequest){
          //本登録以前の施設の場合は、得意先コード変更に合わせて営業担当者も自動設定する
          this.setStaff({
            id: customerInfo.salesStaffId,
            name: customerInfo.salesStaffName,
            mail: customerInfo.salesStaffMail,
          })
        }
      }
    },
    setCpapBilling: function(customerInfo){
      if(customerInfo){
        this.data.belongInfo.cpapBillingCode = customerInfo.customerId;
        this.data.belongInfo.cpapBillingName = customerInfo.customerName;
      }
    },
    setBilling: function(customerInfo){
      if(customerInfo){
        this.data.belongInfo.cpapBillingCode = customerInfo.customerId;
        this.data.belongInfo.cpapBillingName = customerInfo.customerName;
      }
    },
    setStaff: function(staffInfo){
      if(staffInfo){
        this.data.belongInfo.salesStaffId = staffInfo.id;
        this.data.belongInfo.salesStaffName = staffInfo.name;
        this.data.belongInfo.salesStaffAddress = staffInfo.mail;
      }
    },
    setBill: function(billingInfo){
      if(billingInfo){
        this.data.belongInfo.billingId = billingInfo.customerId;
        this.data.belongInfo.billingName = billingInfo.customerName;
      }
    },
    goFacilitySetting: function(){
      var _this = this;
      this.$dialog.confirm({
        title: "　",
        message: "施設別設定に移動します。編集中のデータがある場合は先に「更新」を行ってください。<br>施設別設定に移動しますか？",
        cancelText: "キャンセル",
        onConfirm: async () => {
          this.$router.push({
            name: "DealerFacilitySetting",
            query: {uid: this.uid, from:this.from, belongId: this.data.belongInfo.id}
          });
        }
      });
    },
    changeCheckBox: function(){
      this.data.belongInfo.useService = 0;
      if(this.useHst){
        this.data.belongInfo.useService += this.service.hst;
      }
      if(this.usePsg){
        this.data.belongInfo.useService += this.service.psg;
      }
      if(this.useKenshin){
        this.data.belongInfo.useService += this.service.kenshin;
      }
      if(this.useHolter){
        this.data.belongInfo.useService += this.service.holter;
      }
      if(this.useHolterAnalysis){
        this.data.belongInfo.useService += this.service.holter_analysis;
      }
      if(this.useCPAP){
        this.data.belongInfo.useService += this.service.cpap;
      }

       if (!this.useHolter) {
        this.data.belongInfo.holterDepositSignedFlg = false;
        this.data.belongInfo.holterUseDepositFlg = false;
      }

      if(this.useInspectionReport){
        this.data.belongInfo.useService += this.service.inspection_report;
      }
    },
    changeHolterDepositSignedCheckBox(){      
      if(!this.data.belongInfo.holterDepositSignedFlg){
        this.data.belongInfo.holterUseDepositFlg = false;
      }
    },
    getExternalUserDetail: function(){
      // Web Api Call
      var _this = this;
      var uid = this.uid
      this.apiCall(
        function(client){
          return client.apis.internalMaintenance.getMaintenanceExternalUserDetailPOST({
            body:{
              userId: uid,
              belongsId: uid
            }
          });
        },
        function(result){
          _this.data = result.obj
          console.log("result.obj : " + JSON.stringify(result.obj))
          if(_this.data.userInfo.mail && _this.data.userInfo.mail.startsWith("なし")){
            _this.data.userInfo.mail = "なし"
          }
          _this.useHst = _this.isEnableService(_this.data.belongInfo.useService, _this.service.hst);
          _this.usePsg = _this.isEnableService(_this.data.belongInfo.useService, _this.service.psg);
          _this.useKenshin = _this.isEnableService(_this.data.belongInfo.useService, _this.service.kenshin);
          _this.useHolter = _this.isEnableService(_this.data.belongInfo.useService, _this.service.holter);
          _this.useHolterAnalysis = _this.isEnableService(_this.data.belongInfo.useService, _this.service.holter_analysis);
          _this.useCPAP = _this.isEnableService(_this.data.belongInfo.useService, _this.service.cpap);
          _this.useInspectionReport = _this.isEnableService(_this.data.belongInfo.useService, _this.service.inspection_report);
          _this.mailAddrcomfirm = _this.data.userInfo.mail;
          if(_this.data.belongInfo.cpapDealerRentalFlg){
            _this.cpapDealerRentalFlg = _this.data.belongInfo.cpapDealerRentalFlg + "";
          }
          _this.setPortalSettings(_this.data.portalPublicationRangeSettingInfo);
          _this.getCustomer();
          _this.getSmsHospital();
        },
        function(result){
          _this.showErrorMessage(result);
        }
      );
    },
    postCodeSearch: function(){
      var _this = this;
      return this.apiCall(
        function(client) {
          let postCode = _this.data.belongInfo.customerPostCode;
          return client.apis.apiCommon.getAddressFromPostCodePOST({
            body:{
              postCode: postCode
            }
          });
        },
        function(result) {
          _this.data.belongInfo.prefecture = result.obj.prefecture;
          _this.data.belongInfo.city = result.obj.city;
          _this.data.belongInfo.customerAddress1 = result.obj.town;
        },
        function(error) {
          _this.showErrorMessage(error);
        }
      );
    },
    reload: async function() {
      await this.getExternalUserDetail();
    },
    searchBelongList: async function() {
      // 登録済みの所属先（一時登録フラグがONのもの）を検索する。
      if(this.searchCondition.belongsCustomerCode == "" && this.searchCondition.belongsName == ""){
        this.showErrorMessage("得意先コードまたは組織名を指定してください。");
      } else {
        let _this = this;
        return this.apiCall(
          function(client) {
            return client.apis.internalMaintenance.searchBelongListPOST({
              body: {
                belongsCustomerCode: _this.searchCondition.belongsCustomerCode,
                belongsName: _this.searchCondition.belongsName,
              }
            });
          },
          function(result) {
            // 検索結果表示
            _this.belongsList = result.obj;
          },
          function(error) {
            _this.showErrorMessage(error);
          }
        );
      }
    },
    changeBelongsId: async function() {
      var _this = this;
      this.$dialog.confirm({
        title: "　",
        message: _this.selectedNewBelongs.medicalInstitutionFullName + "（"+ _this.selectedNewBelongs.customerId + "）の組織設定を使用しますか？",
        cancelText: "キャンセル",
        onConfirm: async () => {
          // Web Api Call
          _this.apiCall(
            function(client){
              //所属先IDを変更する。
              return client.apis.internalMaintenance.changeBelongsIdPOST({
                body:{
                  oldBelongsId: _this.data.belongInfo.id,
                  newBelongsId: _this.selectedNewBelongs.belongsId,
                }
              });
            },
            async function(result){
              //変更後再描画
              _this.reload();
              _this.belongsSelected = true;
            },
            function(result){
              _this.showErrorMessage(result);
            }
          ); 
        }
      });
    },
    noChangeBelongsId: async function() {
      var _this = this;
      this.$dialog.confirm({
        title: "　",
        message: _this.data.belongInfo.medicalInstitutionName +  " " + _this.data.belongInfo.departmentName + "を新しい組織として作成しますか？",
        cancelText: "キャンセル",
        onConfirm: () => {
          _this.belongsSelected = true;
        }
      });
    },
    // Search user portal publication range setting.
    setPortalSettings(portalPublicationRangeSetting) {
      if(portalPublicationRangeSetting) {
        this.isEnabledNotice = this.isUsedParam(portalPublicationRangeSetting.isEnabledNotice);
        this.isEnabledGuidance = this.isUsedParam(portalPublicationRangeSetting.isEnabledGuidance);
        this.isEnabledEvent = this.isUsedParam(portalPublicationRangeSetting.isEnabledEvent);
        this.isEnabledNews = this.isUsedParam(portalPublicationRangeSetting.isEnabledNews);
        this.isEnabledProduct = this.isUsedParam(portalPublicationRangeSetting.isEnabledProduct);
        this.isEnabledMail = this.isUsedParam(portalPublicationRangeSetting.isEnabledMail);
      }
    },
    isUsedParam(value) {
      return value != "";
    },
    isDisablePortalItem() {
      return (
        this.data.belongInfo.role == role.role_corporation ||
        this.data.belongInfo.role == role.role_accommodations
      );
    },
    disabledInspectionReport(_class) {
      let disabled = this.useInspectionReport ? '' : 'disabled';
      if (_class) {
        disabled += " " + _class;
      }
      return disabled;
    },
    setSmsHospital: function(smsHospital){
      if(smsHospital){
        this.smsHospital = smsHospital;
        this.data.belongInfo.smsHospitalCode = smsHospital.code;
        this.data.belongInfo.smsHospitalName = smsHospital.name;
      }
    },
    getCustomer: function(){
      if (this.data.belongInfo.customerId) {
        // Web Api Call
        var _this = this;
        this.apiCall(
          function(client){
            return client.apis.apiCommon.getCustomerListPOST({
              body:{
                customerId: _this.data.belongInfo.customerId,
              }
            });
          },
          function(result){
            const customer = result.obj.find((elem) => elem.customerId == _this.data.belongInfo.customerId);
            _this.customer = customer;
          },
          function(result){
            _this.showErrorMessage(result);
          }
        );
      }
    },
    getSmsHospital: function(){
      if (this.data.belongInfo.smsHospitalCode) {
        // Web Api Call
        var _this = this;
        this.apiCall(
          function(client){
            return client.apis.smsInspectionReport.getSmsHospitalListPOST({
              body:{
                hospitalCode:  _this.data.belongInfo.smsHospitalCode,
              }
            });
          },
          function(result){
            const smsHospital = result.obj.find((elem) => elem.code == _this.data.belongInfo.smsHospitalCode);
            _this.smsHospital = smsHospital;
            if (smsHospital) {
              _this.data.belongInfo.smsHospitalName = _this.smsHospital.name;
            }
          },
          function(result){
            _this.showErrorMessage(result);
          }
        );
      }
    },
  },
  data() {
    // 検査解析請求先情報 非活性
    var billingEnabled = false;
    var from = decodeURIComponent(this.$route.query["from"]);
    var uid = parseInt(decodeURIComponent(this.$route.query["uid"]), 10);
    var searchConditions = this.$route.params["searchConditions"];
    var userInfo = this.getUserInfo();
    var salesOfficeMaster = this.getSalesOfficeMaster();
    salesOfficeMaster.unshift({});
    var branchOfficeMaster = this.getBranchOfficeMaster();
    branchOfficeMaster.unshift({});
    return {
      role: role,
      roleId: userInfo.roleId,
      token: userInfo.token,
      service:service,
      extUserStatus:extUserStatus,
      salesOfficeMaster:salesOfficeMaster,
      branchOfficeMaster:branchOfficeMaster,
      coUse: coUse,
      data: null,
      useHst: null,
      usePsg: null,
      useKenshin: null,
      useHolter: null,
      useHolterAnalysis: null,
      useCPAP:null,
      useInspectionReport:null,
      customerModalActive: false,
      cpapBillingModalActive:false,
      staffModalActive: false,
      billModalActive: false,
      coImportModalActive: false,
      smsHospitalModalActive: false,
      from: from,
      uid: uid,
      cpapDealerRentalFlg: "false",
      searchConditions:searchConditions,
      mailAddrcomfirm: "",
      cpapSignedFlg:false,
      cpapUsageDetailBehalf:false,
      billingEnabled: billingEnabled,
      belongsSelected:false,
      belongsList: [],
      selectedNewBelongs: null,
      searchCondition:{belongsCustomerCode:"", belongsName:""},
      invalidPostcode: false,
      invalidPhoneNumber: false,
      // portal menu
      isEnabledNotice: true,
      isEnabledGuidance: true,
      isEnabledEvent: true,
      isEnabledNews: true,
      isEnabledProduct: true,
      isEnabledMail: true,
    };
  },
  filters: {
    branchFilter(value,branchOfficeMaster){
      var target = branchOfficeMaster.find(val => val.code == value)
      if(target){
        return target.name
      }
      return ""
    },
  },
  components: {
    masterNavi: naviBar,
    userNavi: userNaviBar,
    customerModal: CustomerSelectModal,
    staffModal: StaffSelectModal,
    coImportModal: coImportModal,
    smsHospitalModal: SmsHospitalSelectModal,
  },
  mounted: async function() {
    await this.getExternalUserDetail();
  },
  computed: {
    // 半角数字エラーテンプレートメッセージ
    invalidNumberMessage() {
      return invalidNumberMessage;
    },
    // 郵便番号入力におけるプレースフォルダー
    postcodePlaceholder() {
      return postcodePlaceholder;
    },
    // 電話番号入力におけるプレースフォルダー
    phonePlaceholder() {
      return phonePlaceholder;
    },
  },
  watch: {
    "data.belongInfo.customerPostCode"(newValue) {
      this.invalidPostcode = isNaN(Number(newValue));
    },
    "data.belongInfo.phoneNumber"(newValue) {
      this.invalidPhoneNumber = isNaN(Number(newValue));
    },
    "data.belongInfo.role"(newValue) {
      if(this.isDisablePortalItem()) {
        this.isEnabledGuidance = false;
        this.isEnabledEvent = false;
        this.isEnabledProduct = false;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.withButtonField {
  width: 760px !important;
}
.withButton {
  margin-left:10px !important;
  width:150px !important;
  height:29px !important;
}
.coImportButton {
  margin-left:50px !important;
  width:200px !important;
  height:29px !important;
  margin-top: -5px !important;
}
.nameInput {
  width: 462px !important;;
}
.caution {
  color: red;
  font-size: 0.75em;
}
.unlockButton {
  margin-left:10px;
  width:100px !important;
  height:29px !important;
  bottom: 2px;
}
.disabled {
  color: #7a7a7a;
}
.disabled::after {
  background-color: #7a7a7a;
}
.belongsSlectedBtn {
  width:500px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/philips/master/user/ExternalUserEdit.vue